import { useTranslation } from "react-i18next";
import theme from "@monorepo/styles/theme";
import { CartStatusesEnum, DelayStatusesEnum } from "@monorepo/types";
import { styled } from "@mui/material";

interface IProps {
  statusId: CartStatusesEnum;
  delayed: DelayStatusesEnum;
}

const StyledStatus = styled("span", { shouldForwardProp: (prop) => prop !== "paidNotDealyed" })<{
  paidNotDealyed: boolean;
}>(({ paidNotDealyed }) => ({
  color: paidNotDealyed ? "currentColor" : theme.palette.text.disabled,
  fontSize: theme.typography.caption.fontSize,
  marginTop: theme.spacing(1),
}));

export const CartStatus = ({ statusId, delayed }: IProps) => {
  const { t } = useTranslation();

  const getCartStatus = () => {
    switch (true) {
      case delayed === DelayStatusesEnum.DELAYED: {
        return t("cart.statuses.delayed");
      }
      case statusId === CartStatusesEnum.UNPAID: {
        return t("cart.statuses.unpaid");
      }
      case statusId === CartStatusesEnum.PAID: {
        return t("cart.statuses.paid");
      }
      case statusId === CartStatusesEnum.PARTIALLY_PAID: {
        return t("cart.statuses.partially_paid");
      }
      case statusId === CartStatusesEnum.WAITING_INVOICE: {
        return t("cart.statuses.waiting_invoice");
      }
      case statusId === CartStatusesEnum.UPDATE_DATA: {
        return t("cart.statuses.update_data");
      }
      case statusId === CartStatusesEnum.SERIVCE_TURNED_OFF: {
        return t("cart.statuses.service_turned_off");
      }
      case statusId === CartStatusesEnum.PROCEEDING: {
        return t("cart.statuses.proceeding");
      }
      case statusId === CartStatusesEnum.DECLAINED: {
        return t("cart.statuses.declained");
      }
      case statusId === CartStatusesEnum.OVERPAID: {
        return t("cart.statuses.overpaid");
      }
      case statusId === CartStatusesEnum.DECLARED: {
        return t("cart.statuses.declared");
      }
      case statusId === CartStatusesEnum.STALE: {
        return t("cart.statuses.stale");
      }
      default: {
        return null;
      }
    }
  };

  const status = getCartStatus();
  if (status) {
    return (
      <StyledStatus paidNotDealyed={statusId === CartStatusesEnum.PAID && delayed !== DelayStatusesEnum.DELAYED}>
        {status}
      </StyledStatus>
    );
  }
  return null;
};
